import { Atta } from '@/interfaces'
import { User } from '@/interfaces/IUser'
import { CreditoImobiliarioService } from '@/services'
import Fuse from 'fuse.js'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { AutoCompleteBasico } from './AutocompleteBasico'

/**
 * Select global para seleção de parceiros
 */
@Component({})
export class SelectParceiro extends Vue {
	@Prop({ type: Number, required: false }) readonly value!: number
	@Prop({ type: Boolean, required: false, default: true }) readonly required!: number
	lazyValue = this.value

	parceirosList = new Array<Atta.IParceiroListItem>()
	fuseParceirosList: Fuse<Atta.IParceiroListItem> = new Fuse<Atta.IParceiroListItem>(this.parceirosList, { keys: ['nome'] })
	queryParceiro = ''
	isLoading = true
	nomeParceiro: String = ''

	render() {
		return (
			<AutoCompleteBasico
				loading={this.isLoading}
				vModel={this.lazyValue}
				items={this.parceirosListFiltered}
				item-text="nome"
				item-value="id"
				on={{
					'update:search-input': (parceiro: string) => this.buscaParceiro(parceiro),
					change: this.handleInput
				}}
				label="Selecionar um parceiro*"
				rules={[(v: any) => (this.required ? !!v || `Por favor, selecione um parceiro` : true)]}
				{...{ attrs: this.$attrs, props: this.$props }}
				data-cy="select-parceiros"
			/>
		)
	}

	async mounted() {
		this.isLoading = true
		let usuarioId: number = this.user != null ? parseInt(this.user.id!) : -1
		var lista = await CreditoImobiliarioService.score.parceiros.getAll({ uid: usuarioId })
		this.parceirosList = lista
		this.fuseParceirosList = new Fuse<Atta.IParceiroListItem>(this.parceirosList, { keys: ['nome'] })
		this.isLoading = false
	}

	handleInput(event: number) {
		this.lazyValue = event
		this.$emit('change', this.lazyValue)
		this.$emit('input', this.lazyValue)
		this.$emit('nomeParceiro', this.parceirosList.find((listParceiros) => listParceiros.id == this.lazyValue)?.nome)
	}

	get user() {
		const { state } = this.$store
		return state.user as User.IUser
	}

	buscaParceiro(parceiro: string) {
		if (parceiro) {
			var lista = this.fuseParceirosList.search(parceiro).map((u) => u.item)
			this.parceirosList = lista
		}
		// lista completa
		this.parceirosList = this.parceirosList
	}

	get parceirosListFiltered() {
		if (this.fuseParceirosList) {
			if (this.queryParceiro) {
				var lista = this.fuseParceirosList.search(this.queryParceiro).map((u) => u.item)
				return lista
			}
			// lista completa

			return this.parceirosList
		}
		return []
	}
}

export default SelectParceiro
